import React, { FC, ReactElement } from "react";

import { useTranslation } from "react-i18next";
import { Button, Grid, Typography } from "@mui/material";

import { RequestSuccessImage } from "@/assets/images";
import { sanitizeHtml } from "@/core/security";
import { useNavigation } from "@/shared/hooks";

import { StyledPanel } from "../../styled";

export type ActionButton = {
    label: string;
    onClick: () => void;
};

export type InfoPanelProps = {
    icon?: ReactElement;
    message: string;
    loginNeeded?: boolean;
    actionButton?: ActionButton;
};

const InfoPanel: FC<InfoPanelProps> = ({ icon, message, loginNeeded, actionButton }) => {
    const { t } = useTranslation();
    const { navToRoot } = useNavigation();

    return (
        <StyledPanel $color="var(--color-primary-extra-light)" data-testid="success-info-panel">
            {icon || <RequestSuccessImage />}

            <Typography fontSize="var(--size-24)" color="var(--color-primary)" fontWeight="bold">
                {t("Common.ThankYou")}
            </Typography>

            <Typography
                fontSize={{ xs: "var(--size-14)", md: "var(--size-16)" }}
                color="var(--color-grey-900)"
                textAlign="center"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(message) }}
            />

            <Grid container justifyContent="center" gap="20px">
                {actionButton && (
                    <Button
                        variant="outlined"
                        style={{ maxWidth: !loginNeeded ? "fit-content" : "200px" }}
                        onClick={actionButton.onClick}
                        fullWidth
                    >
                        {actionButton.label}
                    </Button>
                )}
                {!loginNeeded && (
                    <Button
                        style={{ maxWidth: actionButton ? "fit-content" : "200px" }}
                        fullWidth
                        onClick={() => navToRoot()}
                    >
                        {t("Common.Close")}
                    </Button>
                )}
            </Grid>
        </StyledPanel>
    );
};

export default InfoPanel;
